"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.LoggingService = void 0;
const inversify_1 = require("inversify");
const _ = require("lodash");
const colors = require("colors/safe");
const core_1 = require("@vacasa/core");
var LoggingServiceLevels = core_1.LoggingServiceNS.LoggingServiceLevels;
let LoggingService = class LoggingService {
    constructor(flowIdService) {
        this.flowIdService = flowIdService;
    }
    static getId() {
        return core_1.LoggingServiceNS.LOGGING_SERVICE_ID;
    }
    getLogger(scope) {
        return new Logger(this.flowIdService, scope);
    }
};
LoggingService = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(core_1.FlowIdServiceNS.FLOW_ID_SERVICE_ID)), __param(0, inversify_1.optional()),
    __metadata("design:paramtypes", [Object])
], LoggingService);
exports.LoggingService = LoggingService;
class Logger {
    constructor(flowIdService, scope) {
        var _a;
        this.flowIdService = flowIdService;
        this.scope = scope;
        const logLevel = (_a = process.env.LOGGER_MIN_LEVEL) !== null && _a !== void 0 ? _a : "verbose";
        this.minLogLevel = LoggingServiceLevels[logLevel.toLowerCase()];
    }
    error(message, data) {
        this.doLog("error", message, data);
    }
    warn(message, data) {
        this.doLog("warn", message, data);
    }
    info(message, data) {
        this.doLog("info", message, data);
    }
    verbose(message, data) {
        this.doLog("verbose", message, data);
    }
    debug(message, data) {
        this.doLog("debug", message, data);
    }
    doLog(level, message, data = {}) {
        var _a, _b;
        if (this.isLevelIgnored(LoggingServiceLevels[level])) {
            return;
        }
        const flowId = (_b = (_a = this.flowIdService) === null || _a === void 0 ? void 0 : _a.getFlowId()) !== null && _b !== void 0 ? _b : "noflowid";
        const scopeWithColor = colors.green(this.scope);
        const levelWithColor = colors.yellow(level);
        const lambda = !!process.env.AWS_LAMBDA_FUNCTION_NAME;
        // AWS lambda already add a level in the logs and this cause conflicts in datadog
        // which doesn't identify the error level logging all as info
        // so we are logging with the appropriate level without passing it inside the params when lambdaMode is true
        const params = lambda
            ? ['{"scope": "%s", "flowId": "%s", "message": "%s", "data": %s}', scopeWithColor, flowId, message]
            : ['{"scope": "%s", "level": "%s", "flowId": "%s", "message": "%s", "data": %s}', scopeWithColor, levelWithColor, flowId, message];
        try {
            if (data instanceof Error) {
                data = _.pick(data, ["message", "stack"]);
            }
            if (!lambda) {
                console.log(...params, Logger.logItem(data));
                return;
            }
            switch (level) {
                case "info":
                case "warn":
                case "error":
                case "debug":
                    console[level](...params, Logger.logItem(data));
                    break;
                default:
                    console.log(...params, Logger.logItem(data));
                    break;
            }
        }
        catch (err) {
            console.error(...params, '"error while logging data"');
        }
    }
    static logField(fieldData) {
        try {
            // check if this field is stringify-able
            const str = JSON.stringify(fieldData);
            if (str === "{}" && fieldData instanceof Error) {
                return fieldData.message;
            }
            return fieldData;
        }
        catch (err) {
            // is not stringify-able
        }
        try {
            return fieldData.toString();
        }
        catch (err) { }
        return "error while logging data";
    }
    /** Try to stringify an item or logs the first level if is not posibble */
    static logItem(data) {
        try {
            if (!data) {
                return JSON.stringify(data);
            }
            if (Array.isArray(data)) {
                return JSON.stringify(_.map(data, Logger.logField));
            }
            if (typeof data === "object") {
                return JSON.stringify(_.reduce(data, (response, value, key) => {
                    response[key] = Logger.logField(value);
                    return response;
                }, {}));
            }
            return JSON.stringify(data);
        }
        catch (err) { }
        return "error while logging data";
    }
    isLevelIgnored(level) {
        return level > this.minLogLevel;
    }
}
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map